import { useAuth0 } from "@auth0/auth0-react"
import { React } from "react"
import { Divider, Icon, Menu } from "semantic-ui-react"
import { parseEnvArray, validateEmail } from "../../../Utils/util"

const BifrostHelpSectionMenu = ({ closeMenu, toggleFeedbackModal }) => {
	const { user } = useAuth0()

	const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || "support@bifrostconnect.com"
	// Use the helper to safely parse the environment variable
	const hideElements = parseEnvArray(process.env.REACT_APP_HELP_SECTION_HIDE_ELEMENTS)
  
	const menuItems = [
		{
			label: "Visit BifrostConnect.com",
			icon: "home",
			url: "https://bifrostconnect.com/",
			renderCondition: hideElements.includes("visit")
		},
		{
			label: "Tours & Tutorials",
			icon: "play circle",
			url: "https://bifrostconnect.com/tours/",
			renderCondition: hideElements.includes("tours")
		},
		{
			label: "Knowledge Center",
			icon: "book",
			url: "https://bifrostconnect.com/docs/",
			renderCondition: hideElements.includes("knowledge")
		},
		{
			label: "Support",
			icon: "mail",
			click: () => {
				console.log("Support")
				window.location.href = `mailto:${supportEmail}`
			},
			renderCondition: hideElements.includes("support")
		},
		{
			label: "Contact Us",
			icon: "talk",
			url: "https://bifrostconnect.com/contact-us/",
			renderCondition: hideElements.includes("contact")
		},
		{
			label: "Direct Tunnel Registration",
			icon: "exchange",
			url: process.env.REACT_APP_NETBIRD_URL + "install",
			renderCondition: process.env.REACT_APP_THEME !== "bifrost" && process.env.REACT_APP_THEME !== "advenica"
		},
		{
			label: "Provide Feedback",
			icon: "comment outline",
			click: () => {
				toggleFeedbackModal(true)
			},
			hasDevider: true,
			renderCondition: !user.email || !validateEmail(user.email) || hideElements.includes("feedback")
		}
	]

	const handleItemClick = (e, { url, click }) => {
		e.preventDefault()
		if (url) {
			closeMenu()
			window.open(url)
		} else if (click) {
			click()
		} else {
			console.log("No action defined")
		}
	}

	return (
		<>
			<Menu borderless vertical style={{ position: "absolute", left: "200px", bottom: "10px", width: "250px", padding: "10px" }}>
				{menuItems.map(
					(item) =>
						!item.renderCondition && (
							<div key={item.label}>
								{item.hasDevider && <Divider />}
								<Menu.Item
									key={item.label}
									content={
										<div style={{ display: "flex", justifyContent: "start", padding: "5px" }}>
											<Icon name={item.icon} />
											<span style={{ marginLeft: "2px" }}>{item.label}</span>
										</div>
									}
									onClick={(e) => handleItemClick(e, { url: item.url, click: item.click })}
								></Menu.Item>
							</div>
						)
				)}
			</Menu>
		</>
	)
}

BifrostHelpSectionMenu.propTypes = {}

export default BifrostHelpSectionMenu
